class HoverZoomer extends HTMLElement {
    // eslint-disable-next-line no-useless-constructor
    constructor() {
        super();
    }

    connectedCallback() {
        this.cache = {};
        if (window.innerWidth > 767 && window.innerWidth < 1024) {
            this._initPinchZoom();
        }
    }

    _appendZoomHint(zoomText = "") {
        if (this.querySelector(".hover-zoomer__hint")) return;
        const zoomHint = document.createElement("div");
        zoomHint.classList.add("hover-zoomer__hint");
        zoomHint.style.display = "flex";
        zoomHint.style.position = "absolute";
        zoomHint.style.left = 0;
        zoomHint.style.right = 0;
        zoomHint.style.bottom = 0;
        zoomHint.style.zIndex = 5;

        const zoomHintParagraph = document.createElement("p");
        zoomHintParagraph.textContent = zoomText;

        zoomHint.appendChild(zoomHintParagraph);

        this.appendChild(zoomHint);
    }

    hideZoomHint() {
        const zoomHint = this.querySelector(".hover-zoomer__hint");
        if (zoomHint) {
            zoomHint.style.display = "none";
        }
    }

    _initPinchZoom() {
        this.pinchImageElementScale = 1;
        this.pinchImageElement = this.querySelector("img");
        this.pinchStart = {};
        this.previousPinchImageElementScale = 1;
        this.previousPinchImageDeltaX = 0;
        this.previousPinchImageDeltaY = 0;

        if (this.pinchImageElement) {
            this.start = {};

            this._appendZoomHint("Pinch to zoom");

            this.pinchImageElement.addEventListener("touchstart", (event) => {
                this.pinchStart.noOfTouches = event.touches.length;
                if (this.pinchStart.noOfTouches === 2) {
                    event.preventDefault(); // Prevent page scroll
                    this.hideZoomHint();

                    // Calculate where the fingers have started on the X and Y axis
                    this.pinchStart.x =
                        (event.touches[0].pageX + event.touches[1].pageX) / 2;
                    this.pinchStart.y =
                        (event.touches[0].pageY + event.touches[1].pageY) / 2;
                    this.pinchStart.distance =
                        this._calculatePinchDistance(event);
                } else {
                    this.pinchStart.x = event.touches[0].pageX;
                    this.pinchStart.y = event.touches[0].pageY;
                }

                this._calculateMaxPinchZoom();
            });

            this.pinchImageElement.addEventListener("touchmove", (event) => {
                // Cover for any scenario where the previous deltaX and deltaY aren't set
                if (this.previousPinchImageDeltaX === undefined)
                    this.previousPinchImageDeltaX = 0;
                if (this.previousPinchImageDeltaY === undefined)
                    this.previousPinchImageDeltaY = 0;
                if (
                    this.pinchStart.noOfTouches === 2 ||
                    this.previousPinchImageElementScale !== 1
                ) {
                    event.preventDefault();
                    event.stopPropagation();

                    let scale = this.previousPinchImageElementScale;
                    let deltaX = this.previousPinchImageDeltaX;
                    let deltaY = this.previousPinchImageDeltaY;

                    const pinchElementRect =
                        this.pinchImageElement.getBoundingClientRect();

                    const deltaXMinThreshold =
                        -(pinchElementRect.width - this.offsetWidth) / 2;
                    const deltaXMaxThreshold =
                        (pinchElementRect.width - this.offsetWidth) / 2;
                    const deltaYMinThreshold =
                        -(pinchElementRect.height - this.offsetHeight) / 2;
                    const deltaYMaxThreshold =
                        (pinchElementRect.height - this.offsetHeight) / 2;

                    if (!this.pinchMaxZoomLevel) {
                        this._calculateMaxPinchZoom();
                    }

                    if (this.pinchStart.noOfTouches === 1) {
                        // Calculate how much the fingers have moved on the X and Y axis
                        deltaX = event.touches[0].pageX - this.pinchStart.x;
                        deltaX += this.previousPinchImageDeltaX;

                        deltaY = event.touches[0].pageY - this.pinchStart.y;
                        deltaY += this.previousPinchImageDeltaY;
                    } else if (event.touches.length === 2) {
                        // Set start pinch distance if it's empty.
                        // This is cover for when a user starts with a single touch, then adds a second touch
                        if (!this.pinchStart.distance) {
                            this.pinchStart.distance =
                                this._calculatePinchDistance(event);
                        }

                        // Calculate the scale manually
                        const deltaDistance =
                            this._calculatePinchDistance(event);
                        scale = (deltaDistance - this.pinchStart.distance) / 50;
                        scale += this.previousPinchImageElementScale;
                        this.pinchImageElementScale = Math.min(
                            Math.max(1, scale),
                            this.pinchMaxZoomLevel,
                        );
                    }
                    deltaX = Math.min(
                        Math.max(deltaXMinThreshold, deltaX),
                        deltaXMaxThreshold,
                    );
                    deltaY = Math.min(
                        Math.max(deltaYMinThreshold, deltaY),
                        deltaYMaxThreshold,
                    );

                    // Transform the image to make it grow and move with fingers
                    this.pinchImageDeltaX = deltaX;
                    this.pinchImageDeltaY = deltaY;
                    this.pinchImageElement.style.transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${this.pinchImageElementScale})`;
                    this.pinchImageElement.style.zIndex = 10;
                }
            });

            this.pinchImageElement.addEventListener("touchend", () => {
                this.previousPinchImageElementScale =
                    this.pinchImageElementScale;
                this.previousPinchImageDeltaX = this.pinchImageDeltaX;
                this.previousPinchImageDeltaY = this.pinchImageDeltaY;
                this.pinchStart.distance = null;
                this.pinchStart.x = null;
                this.pinchStart.y = null;
            });
        }
    }

    _calculatePinchDistance(event) {
        // Calculate distance between two fingers
        return Math.hypot(
            event.touches[0].pageX - event.touches[1].pageX,
            event.touches[0].pageY - event.touches[1].pageY,
        );
    }

    _calculateMaxPinchZoom() {
        if (this.pinchImageElement) {
            const elementBoundingRect = this.getBoundingClientRect();
            // eslint-disable-next-line max-len
            const pinchMaxZoomLevel = (
                this.pinchImageElement.naturalWidth / elementBoundingRect.width
            ).toFixed(1);
            this.pinchMaxZoomLevel = Math.min(
                Math.max(1, pinchMaxZoomLevel),
                3,
            );
        }
    }
}

customElements.define("hover-zoomer", HoverZoomer);
